module.exports = __webpack_public_path__ + "img/lotery-rewards-5.ddc4e446.webp";